import React from 'react';
import { painPoints } from '../data/content';
import { carouselOne } from '../data/carousels';
import { ProjectCarousel } from './ProjectCarousel';
import { RichText } from './RichText';
import { SectionHeading } from './SectionHeading';
export function ForYouSection() {
  return <section className="px-6 py-12" style={{
    marginTop: "-50px",
    marginBottom: "-50px"
  }} data-id="element-27" data-mp="2htb0buqxhaqq">
      <SectionHeading eyebrow="Sound familiar?" data-id="element-28" data-mp="1l31t7obo2wqu">This Mega Kit is for you if…</SectionHeading>

      <ul className="mt-7 space-y-5" data-id="element-29" data-mp="1l5ekis3bejgk">
        {painPoints.map((line, index) => <li key={index} className="flex gap-3.5" data-id="element-30" data-mp="1p4x4nlnbaqic" data-mpi={index}>
            <span className="mt-[11px] h-1.5 w-1.5 shrink-0 rounded-full bg-gold-400" aria-hidden="true" data-id="element-31" data-mp="1u36z1u17pn2w" />
            <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-32" data-mp="1z334lxpk5mkk">
              <RichText line={line} data-id="element-33" data-mp="35ivmemidoo48" />
            </p>
          </li>)}
      </ul>

      <div className="-mx-6 mt-10" data-id="element-34" data-mp="35kzqp5k6vp51">
        <ProjectCarousel images={carouselOne} direction="left" durationSeconds={38} data-id="element-35" data-mp="3ahgoysl3rjvu" />
      </div>
    </section>;
}